import { getWarpedCorners, createWarpTransform } from '@/overlayWarp';

// The perspective part of a distorted layer's transform ('' when it isn't distorted), for a box drawn at `scale`.
export function layerWarpTransform(layer, scale) {
	return createWarpTransform(layer.w * scale, layer.h * scale, layer.props?.warp);
}

export function layerBoxStyle(layer, scale) {
	return {
		position: 'absolute',
		left: 0,
		top: 0,
		width: `${layer.w * scale}px`,
		height: `${layer.h * scale}px`,
		transform: `translate(${layer.x * scale}px, ${layer.y * scale}px) rotate(${layer.rotation || 0}deg) ${layerWarpTransform(layer, scale)}`.trim(),
	};
}

export function layerCorners(layer) {
	const cx = layer.x + layer.w / 2;
	const cy = layer.y + layer.h / 2;
	const rad = (layer.rotation || 0) * Math.PI / 180;
	const cos = Math.cos(rad);
	const sin = Math.sin(rad);
	return getWarpedCorners(layer.w, layer.h, layer.props?.warp)
		.map(([ dx, dy ]) => [ cx + dx * cos - dy * sin, cy + dx * sin + dy * cos ]);
}

export function layerBounds(layer) {
	const corners = layerCorners(layer);
	const xs = corners.map(c => c[0]);
	const ys = corners.map(c => c[1]);
	const left = Math.min(...xs);
	const top = Math.min(...ys);
	return { left, top, right: Math.max(...xs), bottom: Math.max(...ys) };
}

export function pointInLayer(layer, px, py) {
	if(layer.props?.warp) return pointInPolygon(layerCorners(layer), px, py);
	const cx = layer.x + layer.w / 2;
	const cy = layer.y + layer.h / 2;
	const rad = -(layer.rotation || 0) * Math.PI / 180;
	const dx = px - cx;
	const dy = py - cy;
	const lx = dx * Math.cos(rad) - dy * Math.sin(rad);
	const ly = dx * Math.sin(rad) + dy * Math.cos(rad);
	return Math.abs(lx) <= layer.w / 2 && Math.abs(ly) <= layer.h / 2;
}

function pointInPolygon(points, px, py) {
	let inside = false;
	for(let i = 0, j = points.length - 1; i < points.length; j = i++) {
		const [ xi, yi ] = points[i];
		const [ xj, yj ] = points[j];
		if((yi > py) !== (yj > py) && px < (xj - xi) * (py - yi) / (yj - yi) + xi) inside = !inside;
	}
	return inside;
}
